import FeatureGates from '@atlaskit/feature-gate-js-client';
import { autoSuggestionQuery } from '@atlassian/dynamic-cards-search-client';

import { type onError } from '../../error-boundary';
import { type TState } from '../../store/bootstrap';

export const fetchAutoSuggestionResults = (query: string, bootstrap: TState, onError: onError) => {
	const autoSuggestionFilters = {
		entities: ['query-suggestion.query-suggestion-item'],
		locations: [`ari:cloud:confluence::site/${bootstrap.cloudId}`],
	};
	const primaryProduct = bootstrap.primaryProduct;

	const fetchData = async (query: string) => {
		// Confluence killswitch
		// FeatureGates.checkGate('search-plex_auto-suggestion') => false
		if (primaryProduct === 'confluence' && !false) {
			return {
				results: [],
				duration: 0,
			};
		}

		// Atlas killswitch
		if (
			primaryProduct === 'townsquare' &&
			!FeatureGates.checkGate('atlas_enable_query_suggestion_dropdown')
		) {
			return {
				results: [],
				duration: 0,
			};
		}

		performance.mark('fetchAutoSuggestionResultsStart');

		const response = await autoSuggestionQuery({
			variables: {
				limit: 10,
				filters: autoSuggestionFilters,
				query,
			},
		}).catch((error) => {
			onError(error);
		});

		performance.mark('fetchAutoSuggestionResultsEnd');

		const { duration } = performance.measure(
			'fetchAutoSuggestionResultsDuration',
			'fetchAutoSuggestionResultsStart',
			'fetchAutoSuggestionResultsEnd',
		);

		return {
			results: response?.data?.suggest?.suggest?.nodes || [],
			duration,
		};
	};

	return fetchData(query);
};
